module.exports = __webpack_public_path__ + "static/steampunk_registration_form-50a1646cba24cdce1efd8d39cbd2ab03.pdf";